var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_959)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_959",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -171,
    y: -157,
    width: 414,
    height: 414
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243 -157H-171V257H243V-157Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243 -157H-171V257H243V-157Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8592 9C71.4896 9 72 9.48551 72 10.0847V61.9153C72 62.5145 71.4896 63 70.8592 63H1.14075C0.510827 63 0 62.5145 0 61.9153V10.0847C0 9.48551 0.510827 9 1.14075 9H70.8592ZM65.1555 15.5082H6.84454V52.7058L23.2959 31.7159C23.3819 31.6061 23.5162 31.5404 23.6602 31.5376C23.8097 31.5345 23.9417 31.5953 24.0321 31.7016L37.9407 47.9852L48.8223 38.8784C49.0094 38.7217 49.293 38.7328 49.4664 38.9031L65.1555 54.3522V15.5082ZM47.9252 20.6043C51.014 20.6043 53.5216 22.988 53.5216 25.9264C53.5216 28.8657 51.014 31.2482 47.9252 31.2482C44.8343 31.2482 42.3292 28.8655 42.3292 25.9264C42.3292 22.988 44.834 20.6043 47.9252 20.6043Z",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.d31a2480dee137013862c62e852e8f20.svg";
export { ForwardRef as ReactComponent };